'use client'

import React, { ReactElement, ReactNode, useContext, useEffect, useState } from 'react'
import { OpenCloseContext } from '@/components/hotel/OpenCloseContext'
import { Room } from '@/types/Misc'
import ProgramCalender from '@/components/hotel/ProgramCalender'

export function LazyProgramCalender(props: {
  prevIcon: ReactNode
  nextIcon: ReactNode
  programCode: string
  hotelCode: string
  rooms: Room[]
}): ReactElement {
  const [keepOpen, setKeepOpen] = useState(false)
  const { open } = useContext(OpenCloseContext)!

  useEffect(() => {
    if (open) {
      setKeepOpen(true)
    }
  }, [open])

  if (!keepOpen) {
    return <></>
  }

  return <ProgramCalender bookingCode={''} {...props} />
}
